import React from 'react';
import Graphic from './graphics/Graphic2';
import officebookingBg from '../../assets/images/officebooking-bg.jpg';
import GrainBlueBG from '../../assets/images/graphics/graphic1/Grain-Blue-BG.png';
import SwirlBg from '../../assets/images/graphics/graphic2/proxy-background.svg';

export default function Layout({ children }) {
    return (
        <>
            <div className="container-fluid layout">
                <div className="row align-items-lg-center">
                    <div className="col-lg-5 col-sm-12 offset-lg-1">{children}</div>
                    <div className="col-lg-6 col-sm-12 d-none d-lg-block"><Graphic /></div>
                </div>
            </div>
            <div className="full-background" style={{ backgroundImage: `url(${SwirlBg})` }}></div>
        </>
    )
}
